export default "__VITE_ASSET__a44a6f0e__"